/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AbsorbedDoseToWaterUnit = {
    Centigray: 'AbsorbedDoseToWaterUnit.Centigray',
    Milligray: 'AbsorbedDoseToWaterUnit.Milligray',
    Gray: 'AbsorbedDoseToWaterUnit.Gray'
} as const;
export type AbsorbedDoseToWaterUnit = typeof AbsorbedDoseToWaterUnit[keyof typeof AbsorbedDoseToWaterUnit];


export function AbsorbedDoseToWaterUnitFromJSON(json: any): AbsorbedDoseToWaterUnit {
    return AbsorbedDoseToWaterUnitFromJSONTyped(json, false);
}

export function AbsorbedDoseToWaterUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): AbsorbedDoseToWaterUnit {
    return json as AbsorbedDoseToWaterUnit;
}

export function AbsorbedDoseToWaterUnitToJSON(value?: AbsorbedDoseToWaterUnit | null): any {
    return value as any;
}

/**
 * Check if a given object implements the AbsorbedDoseToWaterUnit interface.
 */
 export function instanceOfAbsorbedDoseToWaterUnit(value: any): value is AbsorbedDoseToWaterUnit {
    return Object.values(AbsorbedDoseToWaterUnit).includes(value)
}

